import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import classNames from 'classnames'

import FrameBrowser from 'components/FrameBrowser'
import SectionWrapper from 'components/SectionWrapper'
import { account } from 'constants/externalLinks'
import { REGION_JP } from 'constants/regions'
import { US } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { Text, H1Small as H1 } from 'styles/components/typography'
import { Button } from 'shared/Button'

import { FrameWrapper, Article, BgMovedBlock, Cover } from './styles'

const IMAGE = process.env.region === REGION_JP ? 'dynamic_150921' : 'dynamic'

const BResultsChanges = props => {
  const { data, pathCdn } = props
  const { dict, locale } = useContext(LocalizationContext)
  const isUs = locale === US

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={
        <SectionWrapper
          classNameWrapper='position--full d-none d-md-block'
          className='h-100'
        >
          <div className='h-100 row'>
            <div className='h-100 col-md-6 col-lg-8'>
              <div className='h-100 position-relative'>
                <div className='position--full bg--catskill-white' />
                <BgMovedBlock className='position--full' />
              </div>
            </div>
          </div>
        </SectionWrapper>
      }
    >
      <div className='row'>
        <div className='col-12 col-md-8'>
          <Cover />
          <FrameWrapper className='pb-2 pt-md-4 pb-md-6'>
            <div className='position-relative py-4 py-md-0'>
              <H1 as='h2' dangerouslySetInnerHTML={{ __html: data.title }} />

              <FrameBrowser className={classNames({ 'browser': isUs })} src={`${pathCdn}/${IMAGE}`} alt={IMAGE} />
            </div>
          </FrameWrapper>
        </div>
        <div className='col-12 pt-4 pb-2 pb-md-4 col-md-4'>
          <Article>
            <Text dangerouslySetInnerHTML={{ __html: data.content }} />
            <Button color={'violet'} target={'_blank'} href={account}>
              {dict.buttons.account}
            </Button>
          </Article>
        </div>
      </div>
    </SectionWrapper>
  )
}

BResultsChanges.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default BResultsChanges
